import z from "zod";

export const clientListDataSchema = z.object({
  /** Which clients the page opens on, as the two menu entries do. */
  filter: z
    .enum(["active", "archived", "all"])
    .optional()
    .transform((value) => value ?? "active"),
});

export type ClientListDataProps = z.infer<typeof clientListDataSchema>;
